const TimeType = {
    leg: 0,
    sinceStart: 1,
    passing: 2
};

export default TimeType;